import { NgModule, ModuleWithProviders } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { FnCoreModule } from '../../core/index';

import { FnUiFieldMetaDataService } from './service/fn-ui-field-metadata.service';
import { FnBaseInputComponent } from './base/fn-base-input.component';
import { FnInputComponent } from './fn-input.component';
import { FnInputErrorComponent } from './error-box/fn-input-error.component';

import { FnInputRadioComponent } from './radio/fn-input-radio.component';
import { FnInputCheckboxComponent } from './checkbox/fn-input-checkbox.component';
import { FnTranslateModule } from './../../i18n/index';

export * from './service/fn-ui-field-metadata.service';
export * from './base/fn-base-input.component';
export * from './fn-input.component';
export * from './error-box/fn-input-error.component';

export * from './radio/fn-input-radio.component';
export * from './checkbox/fn-input-checkbox.component';

/** 
 * Exports the required FnBaseInputComponent, FnInputComponent, FnInputErrorComponent, FnInputRadioComponent 
 * And FnInputCheckboxComponent to Create Input Field of different Type with error pop(if input field data is invalid).
 * And Provide FnUiFieldMetaDataService to set MetaData For Input Fields for Different Type.
 * making them available for import by NgModules that import this module.
 */
@NgModule({
    declarations: [FnBaseInputComponent, FnInputComponent, FnInputErrorComponent, FnInputRadioComponent, FnInputCheckboxComponent],
    imports: [FormsModule, CommonModule, FnCoreModule.forRoot(),FnTranslateModule],
    exports: [FnBaseInputComponent, FnInputComponent, FnInputErrorComponent, FnInputRadioComponent, FnInputCheckboxComponent],
    providers: [FnUiFieldMetaDataService]
})
export class FnInputModule {

    static forRoot(): ModuleWithProviders<FnInputModule> {
        return {
            ngModule: FnInputModule,
            providers: [FnUiFieldMetaDataService]
        };
    }
}
